import { render, staticRenderFns } from "./Drugs.vue?vue&type=template&id=0a6e7a4f&lang=pug"
import script from "./Drugs.vue?vue&type=script&lang=js"
export * from "./Drugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,FormDrugs: require('/home/docker/code/frontend/components/form/Drugs.vue').default})
